import React from 'react';
export const IconCheck = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.742",
  height: "19.5",
  viewBox: "0 0 18.742 19.5"
}, /*#__PURE__*/React.createElement("g", {
  id: "document-add-svgrepo-com",
  transform: "translate(-2.25 -1.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7126",
  d: "M17.447,7.984l.408-.439a1.65,1.65,0,0,1,2.451,0,1.96,1.96,0,0,1,0,2.632l-.408.439M17.447,7.984a3.072,3.072,0,0,0,.817,1.755,2.676,2.676,0,0,0,1.634.877M17.447,7.984l-3.755,4.033a6.314,6.314,0,0,0-.491.56,3.156,3.156,0,0,0-.33.573,6.773,6.773,0,0,0-.247.722l-.364,1.173-.118.38m7.756-4.81L16.142,14.65a6.223,6.223,0,0,1-.522.527,2.869,2.869,0,0,1-.534.354,5.759,5.759,0,0,1-.672.265l-1.092.391-.353.127m0,0-.354.127a.445.445,0,0,1-.478-.121.529.529,0,0,1-.113-.514l.118-.38m.827.888-.827-.888",
  transform: "translate(-0.713 -0.733)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7127",
  d: "M8,13h2.2",
  transform: "translate(-0.486 -1.1)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7128",
  d: "M8,9h5.729",
  transform: "translate(-0.451 -0.7)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7129",
  d: "M8,17H9.322",
  transform: "translate(-0.492 -1.5)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7130",
  d: "M18.163,3.054C17.108,2,15.408,2,12.01,2h-1.8c-3.4,0-5.1,0-6.153,1.054S3,5.806,3,9.2v3.6c0,3.394,0,5.091,1.056,6.146S6.81,20,10.208,20h1.8c3.4,0,5.1,0,6.153-1.054.85-.849,1.015-2.114,1.048-4.346",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.5"
})));